import styled, { css, RuleSet } from 'styled-components';
import { palette } from '../../../styles/_palette';
import { ChipsTheme } from './types';

const chipsStyles = {
  [ChipsTheme.Blue]: {
    background: (isActive: boolean) => css`
      background-color: ${({ theme }) =>
        isActive
          ? theme.colors.systemColors.blue
          : theme.colors.background.tertiary};
    `,
    text: (isActive: boolean) => css`
      color: ${({ theme }) =>
        isActive ? theme.colors.background.primary : theme.colors.text.primary};
    `
  },
  [ChipsTheme.White]: {
    background: () => css`
      background-color: ${({ theme }) => theme.colors.background.primary};
      border: 1px solid ${({ theme }) => theme.colors.border.primary};
    `,
    text: () => css`
      color: ${({ theme }) => theme.colors.text.primary};
    `
  },
  [ChipsTheme.Dark]: {
    background: (isActive: boolean) => css`
      background-color: ${({ theme }) => (isActive ? palette.cocoaBrown : theme.colors.background.tertiary)}
      border: 1px solid ${palette.cocoaBrown};
    `,
    text: (isActive: boolean) => css`
      color: ${({ theme }) =>
        isActive ? palette.white : theme.colors.text.primary};
    `
  }
};

export const ChipsLabel = styled.label<{
  $isActive: boolean;
  $isDark?: boolean;
  $borderRadius?: string;
  $customStyles?: RuleSet<object>;
  $chipsTheme: ChipsTheme;
}>`
  display: flex;
  padding: 15px;
  height: 44px;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
  cursor: pointer;
  transition: background-color 0.3s;
  -webkit-tap-highlight-color: transparent;

  border-radius: ${({ $borderRadius }) => $borderRadius || '100px'};
  background: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme: { colors } }) => colors.text.primary};

  ${({ $isActive, $chipsTheme }) =>
    chipsStyles[$chipsTheme].background($isActive)}
  ${({ $isActive, $chipsTheme }) => chipsStyles[$chipsTheme].text($isActive)}

  @media (hover: hover) {
    &:hover {
      ${({ $isActive, $chipsTheme }) =>
        !$isActive &&
        $chipsTheme === ChipsTheme.Blue &&
        css`
          span {
            color: ${({ theme }) => theme.colors.systemColors.blue};
          }
        `}
    }
  }

  ${({ $customStyles }) =>
    $customStyles &&
    css`
      ${$customStyles}
    `}
`;

export const ChipsContent = styled.div<{ $hasIcon?: boolean }>`
  display: flex;
  align-items: center;
  outline: none;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.chips__box {
    display: flex;
    align-items: center;
  }
`;

export const ChipsText = styled.span<{ $isTextPadding?: boolean }>`
  font-size: 15px;
  font-weight: 400;
  ${({ $isTextPadding }) =>
    $isTextPadding &&
    css`
      padding-top: 3px;
    `}
`;

export const ResetButton = styled.div`
  margin-top: 1px;
  margin-left: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
